import { render, staticRenderFns } from "./ModalBloquearAta.vue?vue&type=template&id=16a5401e&scoped=true"
import script from "./ModalBloquearAta.vue?vue&type=script&lang=js"
export * from "./ModalBloquearAta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5401e",
  null
  
)

export default component.exports